<template>
  <pet-form
    :initPet="pet"
    :successMsg="t('updated')"
    :submitAction="submit"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PetForm from '@/views/pets/PetForm.vue'

import Pet from '@/models/Pet'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'pet',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          updated: 'Pet was updated successfully'
        },
        ar: {
          updated: 'تم تحديث الأليف بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    PetForm
  },

  data() {
    return {
      pet: new Pet()
    }
  },

  async beforeMount() {
    try {
      const id = this.$route.params.id
      const petData = await this.$http.get<Pet>(`${Pet.ENDPOINT}/${id}`)
      this.pet = Pet.from(petData)
    } catch (error: any) {
      this.$alertModal.showDanger({ title: error.title, body: error.body })
      await this.$router.push(this.$Route.PETS)
    }
  },

  methods: {
    async submit(pet: Pet) {
      try {
        await this.$http.put(`${Pet.ENDPOINT}/${pet.id}`, pet)
        await this.$router.push(this.$Route.PETS)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
